import { render, staticRenderFns } from "./moreBS.vue?vue&type=template&id=03cd2fe2&lang=pug&"
import script from "./moreBS.vue?vue&type=script&lang=js&"
export * from "./moreBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports